// Import pdfMake with a direct approach for Webpack
const pdfMake = require('pdfmake/build/pdfmake');
// Import fonts
require('pdfmake/build/vfs_fonts');

// Export the properly initialized pdfMake
export default pdfMake;
